import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  id: {
    app_name: "K-LOGIC",
    tagline: "Pelacakan Shipment & Alokasi Stok Terpadu",
    login: "Masuk",
    logout: "Keluar",
    email: "Email",
    password: "Kata Sandi",
    sign_in: "Masuk ke Dashboard",
    dashboard: "Dashboard",
    master_data: "Data Master",
    mappings: "Master Mapping",
    shipments: "Rencana Shipment",
    purchasing: "Pembelian",
    reports: "Laporan",
    finish_goods: "Finish Good",
    cartons: "Master Carton",
    plastics: "Plastic",
    buyers: "Buyer",
    products: "Produk",
    brands: "Brand",
    packing_styles: "Packing Style",
    code: "Kode",
    name: "Nama",
    stock: "Stok",
    unit: "Satuan",
    lead_time: "Lead Time (hari)",
    vendor: "Vendor",
    actions: "Aksi",
    add: "Tambah",
    edit: "Edit",
    delete: "Hapus",
    save: "Simpan",
    cancel: "Batal",
    confirm_delete: "Yakin menghapus item ini?",
    description: "Keterangan",
    required: "Dibutuhkan",
    available: "Tersedia",
    allocated: "Dialokasikan",
    shortage: "Kekurangan",
    sufficient: "Cukup",
    plan_code: "Kode Rencana",
    qty: "Jumlah",
    etd: "ETD",
    eta: "ETA",
    vessel: "Vessel",
    forwarder: "Forwarder",
    container_no: "No. Kontainer",
    peb_no: "No. PEB",
    port_loading: "Port of Loading",
    port_discharge: "Port of Discharge",
    status: "Status",
    priority_report: "Prioritas Pengiriman",
    readiness_report: "Matrix Kesiapan",
    purchasing_report: "Rekomendasi Pembelian",
    outstanding_po: "PO Outstanding",
    stock_ledger: "Ledger Stok Alokasi",
    export_excel: "Ekspor Excel",
    ready: "Siap Kirim",
    pending: "Belum Terpenuhi",
    role: "Peran",
    language: "Bahasa",
    welcome: "Selamat datang kembali",
    kpi_total: "Total Shipment",
    kpi_active: "Shipment Aktif",
    kpi_ready: "Siap Kirim",
    kpi_pending: "Belum Siap",
    kpi_to_buy: "Item Perlu Dibeli",
    kpi_open_po: "PO Terbuka",
    upcoming_shipments: "Shipment Mendatang",
    receive_po: "Terima PO",
    receive_qty: "Jumlah Diterima",
    adjust_stock: "Sesuaikan Stok",
    delta: "Perubahan (+/-)",
    note: "Catatan",
    mapping_selector: "Pilih Buyer / Produk / Brand / Packing",
    shortage_calc: "Hitung Kekurangan",
    create_shipment: "Buat Rencana Shipment",
    product_lines: "Baris Produk",
    add_product_line: "Tambah Produk",
    shipment_subtitle: "Satu rencana bisa berisi beberapa produk & packing style. Isi qty FG, Master Carton dan Plastic per produk.",
    from_stock: "Dari Stok",
    from_po: "Dari PO",
    shipment_shortage: "Kekurangan per Shipment",
    shipment_locked: "Shipment Shipped/Cancelled tidak bisa diedit",
    alloc_hint: "Stok dialokasikan berdasarkan tanggal stuffing paling awal.",
    fill_from_mapping: "Item FG, Master Carton & Plastic ditentukan otomatis dari Mapping",
    mapping_missing: "Kombinasi Buyer, Brand, Product & Packing Style ini belum ada di Mapping. Tambahkan dulu di halaman Mapping.",
    item: "Item",
    kind: "Jenis",
    to_buy: "Harus Dibeli",
    needed_by: "Dibutuhkan Sebelum",
    earliest_etd: "ETD Terdekat",
    incoming: "Dalam Pengiriman",
    po_number: "No. PO",
    expected_date: "Tgl. Diharapkan",
    received: "Diterima",
    remaining: "Sisa",
    initial_stock: "Stok Awal",
    after_alloc: "Setelah Alokasi",
    forecast_balance: "Perkiraan Saldo",
    po_recommendation: "Pembelian harus dilakukan untuk memenuhi shipment",
    no_data: "Tidak ada data",
    register: "Daftar",
    name_field: "Nama Lengkap",
    hello: "Halo",
    inventory: "Stok In/Out",
    inventory_desc: "Catat barang masuk & keluar, lihat summary stok awal, in, out dan stok akhir",
    other_items: "Item Lain",
    stock_in: "Barang Masuk",
    stock_out: "Barang Keluar",
    transactions: "Transaksi",
    stock_summary: "Summary Stok",
    opening_stock: "Stok Awal",
    in_qty: "Masuk",
    out_qty: "Keluar",
    closing_stock: "Stok Akhir",
    date: "Tanggal",
    ref_no: "No. Referensi",
    source: "Sumber",
    doc_no: "No. Dokumen",
    add_line: "Tambah Baris",
    start_date: "Dari Tanggal",
    end_date: "Sampai Tanggal",
    all: "Semua",
    txn_type: "Tipe",
    user: "User",
    create_po_selected: "Buat PO dari Item Terpilih",
    order_date: "Tgl. PO",
    items_label: "Item PO",
    lines_invalid: "Lengkapi item dan qty (> 0) di setiap baris",
    saved: "Tersimpan",
    po_active: "Aktif",
    po_cancelled: "Dibatalkan",
    src_manual: "Manual",
    src_po: "Penerimaan PO",
    src_shipment: "Shipment",
    src_adjust: "Penyesuaian",
    src_opening: "Saldo Awal",
    src_used: "Pemakaian",
    src_transfer: "Transfer",
    src_conversion: "Proses",
    src_opname: "Stock Opname",
    wh_central: "Central",
    wh_stamp: "Stamp",
    wh_printing: "Printing",
    wh_reject: "Stok Reject",
    warehouse: "Gudang",
    used: "Pemakaian",
    transfer: "Transfer Gudang",
    from_wh: "Dari Gudang",
    to_wh: "Ke Gudang",
    same_wh_error: "Gudang asal dan tujuan harus berbeda",
    conversion: "Proses",
    inputs: "Bahan (Input)",
    outputs: "Hasil (Output)",
    rejects: "Reject",
    role_input: "bahan",
    role_output: "hasil",
    audit_log: "Audit Log",
    audit_subtitle: "Riwayat aktivitas: siapa menambah, mengedit atau menghapus data, dan kapan.",
    audit_time: "Waktu",
    audit_action: "Aksi",
    audit_module: "Modul",
    audit_target: "Data",
    wh_fg_wh: "Gudang FG",
    wh_sfg_wh: "Gudang SFG",
    semi_finished_goods: "Semi Finished Good (SFG)",
    copy_table: "Salin Tabel",
    copied: "Tabel disalin, silakan paste di Excel",
    delete_receipt: "Hapus Penerimaan PO",
    deleted: "Berhasil dihapus",
    delete_receipt_hint: "Stok akan dikurangi dan qty terima di PO dihitung ulang. Pilih yang ingin dihapus:",
    delete_receipt_line: "Hapus baris item ini saja",
    delete_receipt_doc: "Hapus seluruh dokumen penerimaan",
    vendors: "Vendor",
    phone: "Telepon",
    address: "Alamat",
    ordered: "Dipesan",
    row: "Baris",
    data: "Data",
    bulk_upload: "Upload Excel",
    choose_file: "Pilih File",
    no_file: "Belum ada file dipilih",
    download_template: "Download Template",
    bulk_check: "Cek File",
    bulk_hint: "Download template, isi di sheet 'Data' mulai baris 2, lalu upload. Sistem mengecek dulu sebelum data disimpan.",
    bulk_new: "Baru",
    bulk_exists: "Sudah ada",
    bulk_error: "Error",
    bulk_dup_warning: "data sudah ada di sistem. Pilih tindakan:",
    bulk_mode_update: "Perbarui data yang sudah ada",
    bulk_mode_skip: "Lewati (data lama tetap)",
    bulk_fix_errors: "Perbaiki baris yang error di file, lalu upload ulang.",
    bulk_import: "Import",
    bulk_done: "Import selesai",
    bulk_created: "baru",
    bulk_updated: "diperbarui",
    bulk_skipped: "dilewati",
    opening_stock: "Stok Awal",
    edit_receipt: "Edit Penerimaan PO",
    cancel_receipt: "Batalkan Penerimaan",
    cancel_receipt_confirm: "Batalkan seluruh penerimaan ini? Stok dikurangi dan qty terima PO dihitung ulang.",
    receipt_qty: "Qty Diterima (dokumen ini)",
    max_qty: "Maks",
    role_admin: "Admin",
    role_marketing: "Marketing",
    role_purchasing: "Purchasing",
    role_viewer: "Viewer",
    users_mgmt: "Kelola Akun",
    users_subtitle: "Tambah, edit, nonaktifkan atau hapus akun, reset password, dan atur halaman yang boleh dilihat/diedit.",
    account: "Akun",
    page: "Halaman",
    permissions: "Hak Akses",
    perm_none: "Tidak",
    perm_view: "Lihat",
    perm_edit: "Edit",
    custom: "Kustom",
    use_role_default: "Pakai default peran",
    admin_full_access: "Admin selalu punya akses penuh ke semua halaman.",
    active: "Aktif",
    inactive: "Nonaktif",
    activate: "Aktifkan",
    deactivate: "Nonaktifkan",
    change_password: "Ganti Password",
    reset_password: "Reset Password",
    current_password: "Password Lama",
    new_password: "Password Baru",
    confirm_password: "Ulangi Password Baru",
    password_min: "Password minimal 6 karakter",
    password_mismatch: "Konfirmasi password tidak sama",
    password_changed: "Password berhasil diubah",
    no_access: "Tidak ada akses",
    no_access_hint: "Akun Anda tidak diberi akses ke halaman ini. Hubungi admin.",
    unlock: "Buka Kunci",
    unlock_confirm: "Buka kunci shipment ini? Status akan menjadi Booked.",
    unlock_confirm_shipped: "Buka kunci shipment ini? Stok yang sudah keluar akan dikembalikan ke gudang dan status menjadi Booked.",
    unlocked: "Shipment dibuka kembali",
    role_reject: "reject",
    difference: "Selisih",
    conversion_need_output: "Isi minimal satu baris hasil atau reject",
    reject_note: "Stok reject disimpan terpisah per item dan tidak dihitung sebagai stok tersedia",
    adjustment: "Adjustment",
    opname: "Stock Opname (jumlah fisik)",
    delta_mode: "Tambah / Kurang",
    physical_qty: "Jumlah Fisik",
    system_qty: "Stok Sistem",
    reason: "Alasan",
    reason_required: "Alasan adjustment wajib diisi",
    from_po: "Dari PO",
    without_po: "Tanpa PO",
    select_po: "Pilih PO",
    select_po_hint: "Pilih PO yang sudah diterbitkan untuk mengisi item yang diterima",
    po_trace: "Lacak PO",
    receipts: "Riwayat Penerimaan",
    no_receipts: "Belum ada penerimaan untuk PO ini",
    all_available: "Semua Gudang (tersedia)",
    summary_all_note: "Total stok tersedia di Central + Stamp + Printing + Gudang FG + Gudang SFG. Stok reject tidak termasuk, transfer antar gudang tidak dihitung sebagai in/out.",
    delete_doc_confirm: "Hapus seluruh dokumen ini? Stok akan dikembalikan",
    rows: "baris",
    clear_filters: "Hapus filter",
    filter_ph: "Filter…",
    expand_menu: "Tampilkan menu",
    minimize_menu: "Kecilkan menu",
    stuffing_date: "Tgl. Stuffing",
    buyer_po: "PO Buyer",
    po_date: "Tgl. PO",
    destination_country: "Negara Tujuan",
    remark: "Remark",
    shipping_line: "Shipping Line",
    bl_number: "BL Number",
    booking_number: "Booking Number",
    edit_doc: "Edit Dokumen",
    header_only_note: "Untuk dokumen ini hanya tanggal, referensi dan catatan yang bisa diubah. Untuk mengubah item, hapus lalu buat ulang.",
    reject_col: "Reject",
  },
  en: {
    app_name: "K-LOGIC",
    tagline: "Unified Shipment Planning & Stock Allocation",
    login: "Sign In",
    logout: "Logout",
    email: "Email",
    password: "Password",
    sign_in: "Enter Dashboard",
    dashboard: "Dashboard",
    master_data: "Master Data",
    mappings: "Master Mapping",
    shipments: "Shipment Planning",
    purchasing: "Purchasing",
    reports: "Reports",
    finish_goods: "Finish Goods",
    cartons: "Master Cartons",
    plastics: "Plastics",
    buyers: "Buyers",
    products: "Products",
    brands: "Brands",
    packing_styles: "Packing Styles",
    code: "Code",
    name: "Name",
    stock: "Stock",
    unit: "Unit",
    lead_time: "Lead Time (d)",
    vendor: "Vendor",
    actions: "Actions",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    confirm_delete: "Delete this item?",
    description: "Description",
    required: "Required",
    available: "Available",
    allocated: "Allocated",
    shortage: "Shortage",
    sufficient: "Sufficient",
    plan_code: "Plan Code",
    qty: "Qty",
    etd: "ETD",
    eta: "ETA",
    vessel: "Vessel",
    forwarder: "Forwarder",
    container_no: "Container No.",
    peb_no: "PEB No.",
    port_loading: "Port of Loading",
    port_discharge: "Port of Discharge",
    status: "Status",
    priority_report: "Shipment Priority",
    readiness_report: "Readiness Matrix",
    purchasing_report: "Purchasing Recommendation",
    outstanding_po: "Outstanding PO",
    stock_ledger: "Stock Allocation Ledger",
    export_excel: "Export Excel",
    ready: "Ready",
    pending: "Pending",
    role: "Role",
    language: "Language",
    welcome: "Welcome back",
    kpi_total: "Total Shipments",
    kpi_active: "Active Shipments",
    kpi_ready: "Ready to Ship",
    kpi_pending: "Pending Fulfillment",
    kpi_to_buy: "Items to Purchase",
    kpi_open_po: "Open POs",
    upcoming_shipments: "Upcoming Shipments",
    receive_po: "Receive PO",
    receive_qty: "Received Qty",
    adjust_stock: "Adjust Stock",
    delta: "Delta (+/-)",
    note: "Note",
    mapping_selector: "Select Buyer / Product / Brand / Packing",
    shortage_calc: "Calculate Shortage",
    create_shipment: "Create Shipment Plan",
    product_lines: "Product Lines",
    add_product_line: "Add Product",
    shipment_subtitle: "One plan can contain several products & packing styles. Enter FG, Master Carton and Plastic qty per product.",
    from_stock: "From Stock",
    from_po: "From PO",
    shipment_shortage: "Shortage per Shipment",
    shipment_locked: "Shipped/Cancelled shipments cannot be edited",
    alloc_hint: "Stock is allocated by earliest stuffing date.",
    fill_from_mapping: "FG, Master Carton & Plastic items are resolved automatically from Mapping",
    mapping_missing: "This Buyer, Brand, Product & Packing Style combination has no Mapping yet. Add it on the Mapping page first.",
    item: "Item",
    kind: "Kind",
    to_buy: "To Buy",
    needed_by: "Needed By",
    earliest_etd: "Earliest ETD",
    incoming: "Incoming",
    po_number: "PO Number",
    expected_date: "Expected Date",
    received: "Received",
    remaining: "Remaining",
    initial_stock: "Initial Stock",
    after_alloc: "After Allocation",
    forecast_balance: "Forecast Balance",
    po_recommendation: "Purchases required to fulfill all shipments",
    no_data: "No data",
    register: "Register",
    name_field: "Full Name",
    hello: "Hi",
    inventory: "Stock In/Out",
    inventory_desc: "Record goods in & out, view opening, in, out and closing stock summary",
    other_items: "Other Items",
    stock_in: "Stock In",
    stock_out: "Stock Out",
    transactions: "Transactions",
    stock_summary: "Stock Summary",
    opening_stock: "Opening Stock",
    in_qty: "In",
    out_qty: "Out",
    closing_stock: "Closing Stock",
    date: "Date",
    ref_no: "Reference No.",
    source: "Source",
    doc_no: "Doc No.",
    add_line: "Add Line",
    start_date: "From",
    end_date: "To",
    all: "All",
    txn_type: "Type",
    user: "User",
    create_po_selected: "Create PO from Selected",
    order_date: "PO Date",
    items_label: "PO Items",
    lines_invalid: "Complete item and qty (> 0) on every line",
    saved: "Saved",
    po_active: "Active",
    po_cancelled: "Cancelled",
    src_manual: "Manual",
    src_po: "PO Receipt",
    src_shipment: "Shipment",
    src_adjust: "Adjustment",
    src_opening: "Opening Balance",
    src_used: "Usage",
    src_transfer: "Transfer",
    src_conversion: "Process",
    src_opname: "Stock Count",
    wh_central: "Central",
    wh_stamp: "Stamp",
    wh_printing: "Printing",
    wh_reject: "Reject Stock",
    warehouse: "Warehouse",
    used: "Usage",
    transfer: "Warehouse Transfer",
    from_wh: "From Warehouse",
    to_wh: "To Warehouse",
    same_wh_error: "Source and destination must differ",
    conversion: "Process",
    inputs: "Material (Input)",
    outputs: "Result (Output)",
    rejects: "Reject",
    role_input: "input",
    role_output: "output",
    audit_log: "Audit Log",
    audit_subtitle: "Activity history: who added, edited or deleted data, and when.",
    audit_time: "Time",
    audit_action: "Action",
    audit_module: "Module",
    audit_target: "Record",
    wh_fg_wh: "FG Warehouse",
    wh_sfg_wh: "SFG Warehouse",
    semi_finished_goods: "Semi Finished Goods (SFG)",
    copy_table: "Copy Table",
    copied: "Table copied, paste it into Excel",
    delete_receipt: "Delete PO Receipt",
    deleted: "Deleted",
    delete_receipt_hint: "Stock is reduced and the PO received qty recalculated. Choose what to delete:",
    delete_receipt_line: "Delete this item row only",
    delete_receipt_doc: "Delete the whole receipt document",
    vendors: "Vendors",
    phone: "Phone",
    address: "Address",
    ordered: "Ordered",
    row: "Row",
    data: "Data",
    bulk_upload: "Upload Excel",
    choose_file: "Choose File",
    no_file: "No file chosen",
    download_template: "Download Template",
    bulk_check: "Check File",
    bulk_hint: "Download the template, fill the 'Data' sheet from row 2, then upload. The system checks everything before saving.",
    bulk_new: "New",
    bulk_exists: "Already exists",
    bulk_error: "Error",
    bulk_dup_warning: "records already exist. Choose an action:",
    bulk_mode_update: "Update existing records",
    bulk_mode_skip: "Skip (keep existing)",
    bulk_fix_errors: "Fix the rows with errors in the file, then upload again.",
    bulk_import: "Import",
    bulk_done: "Import finished",
    bulk_created: "new",
    bulk_updated: "updated",
    bulk_skipped: "skipped",
    opening_stock: "Opening Stock",
    edit_receipt: "Edit PO Receipt",
    cancel_receipt: "Cancel Receipt",
    cancel_receipt_confirm: "Cancel this whole receipt? Stock is reduced and PO received qty recalculated.",
    receipt_qty: "Received Qty (this doc)",
    max_qty: "Max",
    role_admin: "Admin",
    role_marketing: "Marketing",
    role_purchasing: "Purchasing",
    role_viewer: "Viewer",
    users_mgmt: "User Accounts",
    users_subtitle: "Add, edit, deactivate or delete accounts, reset passwords and choose which pages each account can view/edit.",
    account: "Account",
    page: "Page",
    permissions: "Permissions",
    perm_none: "None",
    perm_view: "View",
    perm_edit: "Edit",
    custom: "Custom",
    use_role_default: "Use role defaults",
    admin_full_access: "Admins always have full access to every page.",
    active: "Active",
    inactive: "Inactive",
    activate: "Activate",
    deactivate: "Deactivate",
    change_password: "Change Password",
    reset_password: "Reset Password",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_password: "Repeat New Password",
    password_min: "Password must be at least 6 characters",
    password_mismatch: "Password confirmation does not match",
    password_changed: "Password updated",
    no_access: "No access",
    no_access_hint: "Your account has no access to this page. Contact an admin.",
    unlock: "Unlock",
    unlock_confirm: "Unlock this shipment? Status becomes Booked.",
    unlock_confirm_shipped: "Unlock this shipment? Shipped stock will be returned to the warehouses and status becomes Booked.",
    unlocked: "Shipment reopened",
    role_reject: "reject",
    difference: "Difference",
    conversion_need_output: "Add at least one output or reject line",
    reject_note: "Reject stock is kept separately per item and never counts as available stock",
    adjustment: "Adjustment",
    opname: "Stock Count (physical qty)",
    delta_mode: "Add / Subtract",
    physical_qty: "Physical Qty",
    system_qty: "System Stock",
    reason: "Reason",
    reason_required: "Adjustment reason is required",
    from_po: "From PO",
    without_po: "Without PO",
    select_po: "Select PO",
    select_po_hint: "Select an issued PO to fill in the received items",
    po_trace: "PO Trace",
    receipts: "Receipt History",
    no_receipts: "No receipts for this PO yet",
    all_available: "All Warehouses (available)",
    summary_all_note: "Total available stock in Central + Stamp + Printing + FG Warehouse + SFG Warehouse. Reject stock excluded; transfers between warehouses are not counted as in/out.",
    delete_doc_confirm: "Delete this whole document? Stock will be reverted",
    rows: "rows",
    clear_filters: "Clear filters",
    filter_ph: "Filter…",
    expand_menu: "Expand menu",
    minimize_menu: "Minimize menu",
    stuffing_date: "Stuffing Date",
    buyer_po: "Buyer PO",
    po_date: "PO Date",
    destination_country: "Destination Country",
    remark: "Remark",
    shipping_line: "Shipping Line",
    bl_number: "BL Number",
    booking_number: "Booking Number",
    edit_doc: "Edit Document",
    header_only_note: "For this document only date, reference and note can be changed. To change items, delete and re-create it.",
    reject_col: "Reject",
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "id");
  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("lang", l);
  }, []);
  const t = useCallback((k) => dict[lang][k] ?? dict.en[k] ?? k, [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
